export const MH_API_URL = `https://api.membershiphub.io`;
export const MH_SCRIPT_PROGRAM_ATTRIBUTE = `data-program`;
export const MH_SCRIPT_API_ATTRIBUTE = `data-api`;
export const HIGHLIGHT_IO_PROJECT_ID = `neyv4zze`;
